import { getPercentChangeBetweenTwoNumbers } from '@/utils/mathHelper';
import { GridAggregationFunction } from '@mui/x-data-grid-premium';

/**
 * Realized - % Change (Percentage Change)
 * Based on legacy implementation:
 * https://github.com/Wealth-Access/legacy-ui/blob/main/Scripts/src/Investor/Components/GainsAndLosses/RealizedGainsGrid.jsx#L290
 *
 * Note: This returns a percentage but does not include formatting.
 * The formatting is handled by the column's `valueFormatter` method.
 *
 * https://mui.com/x/react-data-grid/aggregation/#creating-custom-functions
 */
export const realizedGainsPercentChangeAggregation: GridAggregationFunction<
  {
    costBasis: number;
    salePrice: number;
  },
  number
> = {
  getCellValue: ({ row }) => {
    return {
      costBasis: row.CostBasis,
      salePrice: row.SalePrice,
    };
  },
  apply: ({ values }) => {
    let summedCostBasis = 0;
    let summedSalePrice = 0;

    values.forEach((value) => {
      if (value) {
        summedCostBasis += value.costBasis;
        summedSalePrice += value.salePrice;
      }
    });

    return getPercentChangeBetweenTwoNumbers(summedCostBasis, summedSalePrice);
  },
  label: '% change',
  columnTypes: ['number'],
};
